<div class="tip-card-v2">
  <div class="title">Tip To Ketto Volunteer</div>
  <div class="subtitle">If you like what we are doing support us by adding a tip of 18%</div>

  <div *ngIf="!otherTipCard" class="tips">
    <button *ngFor="let item of tips"
            (click)="selectTip({value:item.percent})"
            [ngClass]="{'active-pill': selectedTip === item.percent}"
            mat-stroked-button>
      <div>{{item.percent}}%</div>
      <div *ngIf="item.percent===(currency !== 'INR' ? 10 : 18)" class="most-tip">most tipped</div>
    </button>
    <button (click)="otherTipCard=true; onTipInput()"  mat-stroked-button>Other</button>
  </div>

  <div class="other-tip-input" [ngClass]="{'expand-tip-input': otherTipCard}">
    <mat-form-field appearance="legacy" [formGroup]="customAmountForm">
      <input matInput
            type="number"
            min="0"
            [formControl]="customAmount"
            (input)="onTipInput()">
      <div class="currency-prefix" matPrefix>
        <app-currency-icon [currency] = "currency"></app-currency-icon>
      </div>
    </mat-form-field>
    <button (click)="otherTipCard=false; selectTip({value: selectedTip})" mat-icon-button>
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
</div>
